import { FC } from 'react';

const Footer: FC = () => {
  return (
    <footer className="mt-auto py-5 bg-dark">
      <div className="container d-flex justify-content-center">
        <span className="text-muted">Copyright &copy; Website 2024</span>
      </div>
    </footer>
  );
};

export default Footer;
